import styled from 'styled-components';
import ProductCard from '../card/ProductCard';

export default function SpartPartSelecction({ product }) {

    if (!product) {
        return <h3 style={{textAlign: 'center', margin: '2rem 0rem'}}> Seleccione una Marca y un Producto para ver sus repuestos</h3>;
    }

    const { producto } = product;

    return (
        <StyledSpartPartSelection>
            <div className="containerSpartParts">
                <ProductCard product={producto} type="spare_part" />
            </div>
        </StyledSpartPartSelection>
    );
}

const StyledSpartPartSelection = styled.div`
    .containerSpartParts{
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 2rem 0rem;
        @media (min-width: 992px){
            padding: 0rem 0rem 0rem 3rem;
        }
    }
`
